var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcres(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154,
    height: 154,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 77,
    r: 70.5,
    fill: "#feda9b",
    stroke: "#ffffff",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 77,
    cy: 77,
    r: 67,
    fill: "#feda9b",
    stroke: "#2e425a",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2e425a",
    d: "m34.6 99.9 41.8-26.2 41.8 26.2v11l-41.8 26.2-41.8-26.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#feda9b",
    stroke: "#2e425a",
    strokeWidth: 3,
    d: "m37.5 99.9 38.9-24.4 38.9 24.4-38.9 24.4zm13-8.1 38.9 24.4m13-8.1L63.5 83.7m26 0-38.9 24.4m13 8.1 38.9-24.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10,
    d: "M114 52.3V60c8.6 1.8 12.6.8 11.9-3.2zm0 0a6.6 6.6 0 0 0-.3-1.3 8.1 8.1 0 0 0-5.5-5.3l-1.7-.2c-1.1 0-2.2.2-3.2.7a15 15 0 0 0-3.3 2.2l-3 3a12.6 12.6 0 0 1-10.9 5.9H77l-14.7-23-7.1-11a45.6 45.6 0 0 0-10 29.6 62 62 0 0 0 4.3 19 36.6 36.6 0 0 0-9.4 11A37 37 0 0 1 51.4 77a44.8 44.8 0 0 1 13.7-2h11.7a25.7 25.7 0 0 0 17.3-6.2 138 138 0 0 1 6.7-4.5c4.8-2.7 9.1-4 13-4.2h.3m-31.4-2.6V21c-7.5.5-14.4 5-20.5 13.3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc00e",
    d: "M114 52.3V60c8.6 1.8 12.6.8 11.9-3.2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2e425a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.1,
    d: "M114 60c8.6 1.8 12.6.8 11.9-3.2l-12-4.5"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M114 53.2v-1a6.6 6.6 0 0 0-.3-1.2 8.1 8.1 0 0 0-5.5-5.3l-1.7-.2c-1.1 0-2.2.2-3.2.7a15 15 0 0 0-3.3 2.2l-3 3a12.6 12.6 0 0 1-10.9 5.9H77l-14.7-23-7.1-11a45.6 45.6 0 0 0-10 29.6 62 62 0 0 0 4.3 19 36.6 36.6 0 0 0-9.4 11A37 37 0 0 1 51.4 77a44.8 44.8 0 0 1 13.7-2h11.7a25.7 25.7 0 0 0 17.3-6.2 138 138 0 0 1 6.7-4.5c4.8-2.7 9.1-4 13-4.2h.3zM82.8 21a25 25 0 0 0-16.2 8.2l16.2 25.3z",
    style: {
      fill: "url(#a)"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#d9bfb3",
    d: "M66.3 29.4a64.9 64.9 0 0 0-4.1 5l14.7 23h5.8v-2.9L66.5 29.2Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2e425a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.1,
    d: "M66.5 29.2a20.6 20.6 0 0 1-1.3 1.4l-3 3.7 14.7 23h5.8v-2.8M66.5 29.2A25 25 0 0 1 82.7 21v33.5m0 2.9h3.5c3.3-.1 6.1-1.1 8.4-3.2.9-.8 1.7-1.7 2.5-2.7a24 24 0 0 1 3-3.1 15 15 0 0 1 3.2-2.2 7.4 7.4 0 0 1 4.9-.5 8.1 8.1 0 0 1 5.6 5.5l.2 1V60h-.1c-4 .1-8.3 1.5-13.1 4.2a138 138 0 0 0-9.1 6.3l-2 1.2A25.7 25.7 0 0 1 76.8 75H65.1A43.4 43.4 0 0 0 40 83a38 38 0 0 1 9.4-11 63.3 63.3 0 0 1-4.3-19c-.2-11 3.1-21 10-29.7l7 11.1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 77,
    x2: 77,
    y1: 35,
    y2: 96.9,
    gradientTransform: "translate(0 -14)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEAE8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcres);
export default __webpack_public_path__ + "static/media/ACRES.39119be66e91c767d9191d7004b18011.svg";
export { ForwardRef as ReactComponent };